import { render, staticRenderFns } from "./PopularProducts.vue?vue&type=template&id=2fa1bf95&"
import script from "./PopularProducts.vue?vue&type=script&lang=js&"
export * from "./PopularProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports